import { render } from "./AbsTekerlekHizSensoru.vue?vue&type=template&id=2d086bca"
import script from "./AbsTekerlekHizSensoru.vue?vue&type=script&lang=js"
export * from "./AbsTekerlekHizSensoru.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__